import { ReactSipPhone, Dialpad } from 'react-sip-phone';
import 'react-sip-phone/dist/index.css';

import './PhoneWidget_.scss';
import { translate } from '@chaika/i18n/helper';

export interface PhoneWidgetProps {}

interface Props extends PhoneWidgetProps {
    sipuri: string;
    password: string;
    websocket: string;
    isOnLoad: boolean;
    currentDialString: string;
    onDialpadButtonClick(value: string): void;
    onDialStringChange(e: React.ChangeEvent<HTMLInputElement>): void;
    onStartNewSession(): void;
    onSessionTerminated(): void;
}

export function PhoneWidget({
    sipuri,
    password,
    isOnLoad,
    websocket,
    currentDialString,
    onDialpadButtonClick,
    onDialStringChange,
    ...handlers
}: Props) {
    console.info('Connect to asterisk', sipuri);
    return !isOnLoad && !!sipuri ? (
        <div className={'phone_widget_root'}>
            <ReactSipPhone
                currentDialString={currentDialString}
                onDialStringChange={onDialStringChange}
                containerStyle={{}}
                width={300}
                height={400}
                name={translate('setting')}
                phoneConfig={{
                    defaultDial: '',
                    disabledButtons: ['numpad'],
                    disabledFeatures: [],
                    sessionsLimit: 1,
                    attendedTransferLimit: 2,
                    autoAnswer: false,
                }}
                appConfig={{
                    mode: '',
                    started: false,
                    appSize: 'large',
                }}
                sipCredentials={{
                    sipuri,
                    password,
                }}
                sipConfig={{
                    websocket,
                    video: false,
                    defaultCountryCode: '7',
                    iceServers: [],
                    noAnswerTimeout: 999999,
                    ...handlers,
                }}
            />
            <Dialpad
                open
                onButtonClick={onDialpadButtonClick}
            />
        </div>
    ) : (
        <div />
    );
}
